/**
 * Generated by orval v7.9.0 🍺
 * Do not edit manually.
 * Meeting BaaS API
 * API for managing meeting bots, calendar integrations, and webhooks
 * OpenAPI spec version: 2.0.0
 */

export type GetScheduledBotResponseDataTranscriptionConfigAnyOfProvider =
  (typeof GetScheduledBotResponseDataTranscriptionConfigAnyOfProvider)[keyof typeof GetScheduledBotResponseDataTranscriptionConfigAnyOfProvider]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetScheduledBotResponseDataTranscriptionConfigAnyOfProvider = {
  gladia: "gladia",
  deepgram: "deepgram",
  assemblyai: "assemblyai",
  speechmatics: "speechmatics",
  soniox: "soniox"
} as const
